module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-alpha-down-a0e25390.svg";